import {FC} from "react";

export const NotFoundPage: FC = () => {
	return (
		<div>
			Page not found
		</div>
	);

}